import thunk from "redux-thunk";
import {applyMiddleware, createStore, compose, combineReducers} from "redux";
import {connectRouter, routerMiddleware} from "connected-react-router";


export function configureStore({history, reducers = {}}) {
    const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const connectedRouter = connectRouter(history);
    const middlewares = [
        thunk,
        routerMiddleware(history),
    ];

    return createStore(
        combineReducers({...reducers, router: connectedRouter}),

        composeEnhancer(applyMiddleware(...middlewares))
    );
}